import { AlertService, ALERT_TYPES, Alert } from '@edassist/shared';
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { constants } from './alert.constants';

@Component({
	selector: 'ea-alert',
	templateUrl: './alert.component.html',
	styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit, AfterViewInit {
	@Input() alert: Alert;
	@Input() canDismiss = true;
	@Input() dismissOnTimeout: number;

	alertClass: string;
	alertIconClass: string;

	isDismissed = false;

	ngOnInit(): void {
		this.setAlertIconClass(this.alert);
		this.setAlertClass(this.alert);
	}

	ngAfterViewInit(): void {
		this.dismissAlertOnTimeout();
	}

	dismissAlertOnTimeout(): void {
		if (this.canDismiss && this.dismissOnTimeout) {
			setTimeout(() => {
				this.removeAlert();
			}, this.dismissOnTimeout);
		}
	}

	constructor(private readonly alertService: AlertService) {}

	removeAlert(): void {
		this.isDismissed = true;
		this.alertService.clear();
	}

	private setAlertIconClass(alert: Alert): void {
		switch (alert.type) {
			case ALERT_TYPES.Success:
				this.alertIconClass = constants.alerts.iconClasses.success;
				break;
			case ALERT_TYPES.Error:
				this.alertIconClass = constants.alerts.iconClasses.error;
				break;
			case ALERT_TYPES.Info:
				this.alertIconClass = constants.alerts.iconClasses.info;
				break;
			case ALERT_TYPES.Warning:
				this.alertIconClass = constants.alerts.iconClasses.warning;
				break;
			default:
				this.alertIconClass = constants.alerts.iconClasses.info;
		}
	}

	private setAlertClass(alert: Alert): void {
		// return css class based on alert type
		switch (alert.type) {
			case ALERT_TYPES.Success:
				this.alertClass = constants.alerts.alertClasses.success;
				break;
			case ALERT_TYPES.Error:
				this.alertClass = constants.alerts.alertClasses.error;
				break;
			case ALERT_TYPES.Info:
				this.alertClass = constants.alerts.alertClasses.info;
				break;
			case ALERT_TYPES.Warning:
				this.alertClass = constants.alerts.alertClasses.warning;
				break;
			default:
				this.alertClass = constants.alerts.alertClasses.info;
		}
	}
}
